


























































































































interface ProductSelectValue {
  id: string;
  title: string;
  is506c?: boolean;
}

import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import Header from "@/types/app/header";
import SubDocumentInvestorsInterface, {
  InvestorCompleteInterface,
  SubdocumentsFilesI,
} from "@/types/app/subdocument";
import CustomerProduct from "@/components/headers/customer-products";
import formatDate from "@/utils/formatDate";
import applyCondition from "@/utils/applyCondition";
import Endpoint from "@/utils/endpoint";
import { getFileNameFromLink } from "@/utils/fileName";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import compareTo from "@/utils/compareTo";
import Product from '@/types/app/products';
import { Getter } from "vuex-class";
import TemplateEmailDocument from "@/utils/templateEmailDocuments";
import { getProductFunds } from "@/utils/getProductFund";
import AccountService from "@/services/accountService";
import AccountInterface from "@/types/app/accounts";
import AccountDocumentHeader from "@/components/headers/account-documents";

interface AccountFile {
  index: number;
  email: string;
  userId: string;
  accountNumber: string;
  fundName: string;
  category: string;
  fundId: string;
  file: File;
  effectiveDate: string;
  investorName: string;
}
interface ImportDataAzure {
  fund: any;
  accounts: AccountFile[];
  category: string;
}

@Component({

})


export default class AccountDocuments extends BaseComponent {

  @Getter('getOnlyPublished', { namespace: 'product' })
  products!: Product[];

  headers: Header[] = AccountDocumentHeader.header;
  investors: SubDocumentInvestorsInterface[] = [];
  nameFilter = "";
  emailFilter = "";
  loading = false;
  loadingSubdocsFiles = false;
  investorDetail = {};
  openInvestorDetailModal = false;
  openSendContractModal = false;
  private accountService = new AccountService(this.$http);
  subdocumentsFiles: SubdocumentsFilesI[] = [];
  importData: ImportDataAzure = { accounts: [], category: '', fund: {} }
  selectedInvestors = [];
  files = []
  selectedFileToFill: any = {};
  private endpoint = new Endpoint();
  documents: VuetifySelectItems[] = TemplateEmailDocument.CategoryDocuments;
  funds: VuetifySelectItems[] = [];
  accounts: AccountInterface[] = [];
  statusFormFillColor = {
    "Not Started": "not-started",
    "Filling in": "filling-in",
    Filled: "filled",
  };
  productsSelect: VuetifySelectItems[] = [];
  productId = "";

  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;



  async mounted() {
    const [productsResponse, accountResponse] = await Promise.all([getProductFunds(this.$http),
    this.accountService.getAccounts()]);
    this.funds = productsResponse;
    this.accounts = accountResponse;
  }


  changeDisableFile(): boolean {
    return this.importData.category == '' || this.importData.fund == undefined
  }


  async loadAccountFiles(files: File[]) {
    console.log('createSubdocumentFile', files);
    this.importData.accounts = [];
    let index = 0;
    files.forEach(file => {

      const accountNumber = file.name.split(' - ').pop()?.split('.')[0];
      const dtFile = file.name.split(' - ')[2];
      this.accounts.filter(a => a.accountNumber == accountNumber && a.fundId == this.importData.fund.value).forEach(account => {
        console.log('accountNumber', accountNumber, account);

        const accountUser = {
          accountNumber: account.accountNumber,
          email: account.email,
          userId: account.userId,
          fundName: account.fundName,
          fundId: account.fundId,
          category: this.importData.category,
          index: index++,
          effectiveDate: dtFile,
          file: file,
          investorName: account.investorName
        };
        this.importData.accounts.push(accountUser);

      });
    });
    console.log('importData', this.importData);
  }




  async uploadToAzure() {
    this.loading = true;
    try {
      console.log('selectedInvestors', this.selectedInvestors);
      const body = {
        importData: this.selectedInvestors
      };
      const formData = new FormData();

      this.selectedInvestors.forEach((account: AccountFile, index) => {
        formData.append(`azureRequests[${index}].accountNumber`, account.accountNumber);
        formData.append(`azureRequests[${index}].category`, account.category);
        formData.append(`azureRequests[${index}].email`, account.email);
        formData.append(`azureRequests[${index}].fundId`, account.fundId);
        formData.append(`azureRequests[${index}].fundName`, account.fundName);
        formData.append(`azureRequests[${index}].userId`, account.userId);
        formData.append(`azureRequests[${index}].effectiveDate`, account.effectiveDate);
        formData.append(`azureRequests[${index}].fileName`, account.file.name)
        formData.append(`azureRequests[${index}].file`, account.file);
      });

      const result = await this.$http.post(this.endpoint.uploadToAzure, formData);
      if ((result as any)?.hasErrors || result.data?.hasErrors) {

        this.logHttpError(result);
        this.loading = false;
      }
      else {
        this.showSuccess('Documents uploaded to azure successfully!');

        this.importData.accounts = this.importData.accounts.filter(a => !this.selectedInvestors.some((i: AccountFile) => i.index == a.index));
        if (this.importData.accounts.length == 0) {
          this.importData.fund = {};
          this.importData.category = '';
        }
        this.selectedInvestors = [];
        this.loading = false;
      }


    }
    catch (ex) {
      this.logException(ex);
      this.loading = false;
    }


  }
}
